import i18n from '@/i18n';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import en from 'vuetify/lib/locale/en';
import ar from 'vuetify/lib/locale/ar';
import { colors } from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	rtl: i18n.locale === 'ar',
	lang: {
		locales: { en, ar },
		current: i18n.locale,
	},
	theme: {
		themes: {
			light: {
				primary: '#274c78',
				// primary: '#1a9989',
				'mid-primary': '#3b678e',
				'light-primary': '#6096ba',
				preview: colors.deepPurple,
				'edit-color': '#db802a',
				alert: colors.red.lighten1,
				addRow: '#009c00',
				info: '#009999',
				secondary: '#009c00',
				alt: '#009999',
				'alert-color': '#dd0013'
			},
		},
	},
	icons: {
		values: {
			add: 'mdi-plus-circle-outline',
			view: 'mdi-eye',
			viewEmployee: 'mdi-account-eye',
			edit: 'mdi-pencil',
			close: 'mdi-close',
			delete: 'mdi-delete',
			search: 'mdi-magnify',
			info: 'mdi-information',
			calendar: 'mdi-calendar',
			addRow: 'mdi-plus-circle-outline',
			ratingEmpty: 'mdi-circle-outline',
			ratingFull: 'mdi-circle',
		},
	},
});
